import React, { useState } from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import { DoubleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import { useTranslation } from 'react-i18next'
import WhitepapersTab from './../../components/WhitepapersTab';
import banking_whitepaper from "../../assets/images/contents/banking-whitepaper.png"
import eu_dcc_whitepaper from "../../assets/images/contents/eudcc-whitepaper.gif"
import testing_inspection_whitepaper from "../../assets/images/contents/testing-inspection-whitepaper.png"
import hr_document from "../../assets/images/contents/hr-document-security.png"
import pdf_stamping from "../../assets/images/contents/stamping-pdf.png"
import info_graphic from "../../assets/images/contents/info-graphic.png"
import document_security_2023 from "../../assets/images/contents/document-security.png"
import { CustomPagination, StyledLink } from '../../components/StyledComponents'
import filter_color from "../../assets/images/design/colorFilter.svg"

const AllWhitepapers = () => {
    const { t } = useTranslation()

    const itemsPerPage = 6;
    const [currentPage, setCurrentPage] = useState(1);

    const items = [
        {
            id: 1,
            link: '/whitepapers/banking',
            image: banking_whitepaper,
            chip: t("whitepapers-tab.banking-whitepaper"),
            title: t('whitepapers.banking-title'),
            content: t('whitepapers.banking-content')
        },
        {
            id: 2,
            link: '/whitepapers/eu-dcc',
            image: eu_dcc_whitepaper,
            chip: t("whitepapers-tab.eu-dcc-whitepaper"),
            title: t('whitepapers.eudcc-title'),
            content: t('whitepapers.eudcc-content')
        },
        {
            id: 3,
            link: '/whitepapers/testing-inspection',
            image: testing_inspection_whitepaper,
            chip: t("whitepapers-tab.testing-inspection-whitepaper"),
            title: t('whitepapers.testing-inspection-title'),
            content: t('whitepapers.testing-inspection-content'),
        },
        {
            id: 4,
            link: '/whitepapers/hr-document-security',
            image: hr_document,
            chip: t("whitepapers-tab.hr-document-security-whitepaper"),
            title: t('whitepapers.hr-document-security-title'),
            content: t('whitepapers.hr-document-security-content')
        },
        {
            id: 5,
            link: '/whitepapers/pdf-stamping',
            image: pdf_stamping,
            chip: t("whitepapers-tab.pdf-stamping-whitepaper"),
            title: t('whitepapers.pdf-stamping-title'),
            content: t('whitepapers.pdf-stamping-content')
        },
        {
            id: 6,
            link: '/whitepapers/infographic-on-bank-fraud',
            image: info_graphic,
            chip: t("whitepapers-tab.banking-whitepaper"),
            title: t('whitepapers.info-graphic-title'),
            content: t('whitepapers.info-graphic-content')
        },
        {
            id: 7,
            link: '/whitepapers/document-security',
            image: document_security_2023,
            chip: t("whitepapers-tab.document-security-whitepaper"),
            title: t('whitepapers.document-security-title'),
            content: t('whitepapers.document-security-content')
        },

    ];

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const currentItems = items.slice(startIndex, endIndex);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    // const handlePrevClick = () => {
    //     setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    // };

    // const handleNextClick = () => {
    //     setCurrentPage((prevPage) => Math.min(prevPage + 1, Math.ceil(items.length / itemsPerPage)));
    // };

    return (
        <div className='whitepapers bg-primary'>
            <div className='color-filter-right' style={{ top: "35%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "55%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <Navbar />
            <div className='container-fluid whitepapers-header pb-100'>

            </div>
            <div className='container whitepapers-margin'>
                <div className='col-sm-12'>
                    <p className='font-weight-bold text-center font-96 whitepapers-header-title uppercase'>Whitepapers</p>
                </div>
                <div className='col-sm-12 flex justify-center pt-100'>
                    <DoubleCustomBreadCrumbs currentPage={t('bread-crumbs.whitepapers')} />
                </div>
            </div>
            <div className='mt-lg-150 pt-50'>
                <WhitepapersTab allWhitepapersActive={true} />
            </div>
            <div className="whitepapers-content container">
                <div className='row'>
                    {currentItems.map((item, index) => (
                        <div className='col-xl-4 col-md-6' key={item.id}>
                            <div className="whitepapers-card">
                                <StyledLink href={item.link}>
                                    <div className='whitepapers-card_image'>
                                        <img src={item.image} alt="" className='img-responsive' />
                                    </div>
                                </StyledLink>
                                <div className='case-study-chip mt-20'>
                                    {item.chip}
                                </div>
                                <StyledLink href={item.link}>
                                    <p className='pt-20 text-white font-20 font-weight-semi-bold'>{item.title}</p>
                                </StyledLink>
                                <p className='text-gray pt-20'>{item.content}</p>
                            </div>

                        </div>
                    ))}
                </div>

                <div className='mt-50 flex justify-center'>
                    <CustomPagination
                        count={Math.ceil(items.length / itemsPerPage)}
                        page={currentPage}
                        onChange={handlePageChange}
                    />
                </div>
            </div>


            <div className='container'>
                <IndustriesImageContainer />
            </div>
            <Footer />
        </div>
    )
}

export default AllWhitepapers